import styled from "styled-components";
import { Search } from "@styled-icons/boxicons-regular/Search";
import { Delete } from "@styled-icons/fluentui-system-filled/Delete";
import { EditAlt } from "@styled-icons/boxicons-regular/EditAlt";
import { Category } from "@styled-icons/boxicons-regular/Category";
import { School } from "@styled-icons/ionicons-outline/School";
import { Newspaper } from "@styled-icons/ionicons-outline/Newspaper";
import { PaperPlane } from "@styled-icons/ionicons-outline/PaperPlane";
import { DeleteDismiss } from "@styled-icons/fluentui-system-regular/DeleteDismiss";
import { LearningApp } from "@styled-icons/fluentui-system-regular/LearningApp";
import { Check2Circle } from "@styled-icons/bootstrap/Check2Circle";
import { Create } from "@styled-icons/ionicons-outline/Create";
import { PencilSquare } from "@styled-icons/bootstrap/PencilSquare";


import Foto from "../../assets/img/topo.jpg";

export const MainWrapper = styled.div`
  background-color: #f5f5f5;
  width: 100%;
  min-height: 100vh;
  color: #fff;

  .dropdown-item {
    color: #333 !important;
  }

  .bgdark {
    background-color: #007bc6;
    margin-left: -15px;

    a {
      background-color: #05367f;
      margin-bottom: 1px;
      color: #fff;
    }

    hr {
      border-top: 1px solid #3b95f2;
      margin: 10px 0px;
    }
  }

  .btn-primary {
    background-color: #05367f;
    display: block;
    border: 0px;
    width: 100%;
  }

  .card {
    margin: 15px 0px;
  }
`;

export const WrapperTurma = styled.div`
  background-image: url("${Foto}");
  background-position: bottom center;
  background-size: cover;
  display: flex;
  width: 100%;
  height: 250px;
  line-height: 12px;
  font-size: 12px;
  padding: 40px;
  color: #eee;
  flex-direction: column;
  align-content: flex-end;
  justify-content: flex-end;
  margin: 15px 0px;
  border-radius: 10px;

  strong {
    display: inline-block;
    font-size: 32px;
    color: #fff;
    border-bottom: 1px solid #fff;
    padding-bottom: 20px;
    margin-bottom: 0px;
  }
`;

export const MainContent = styled.div`
  background-color: #fff;
  padding: 15px;
  display: block;
  margin: 10px 0px;
  color: #333;

  .pull-right {
    position: relative;
    float: right;
  }
`;

export const TopButton = styled.div`
  position: absolute;
  right: 20px;
  top: 10px;
  z-index: 9;
  cursor: pointer;
`;

export const TipoAviso = styled.div`
  width: 60px;
  min-width: 60px;
  height: 60px;
  min-height: 60px;
  margin: 0 auto 15px;
  background: linear-gradient(135deg, #007bc6 0%, #0056b3 100%);
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 20px rgba(0, 123, 198, 0.3);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 123, 198, 0.4);
  }
`;

export const CaixaTexto = styled.div`
  display: block;
  width: 100%;
  position: relative;
  min-height: 45px;
  overflow: hidden;
  padding: 8px 0px;
  font-size: 14px;
  line-height: 1.3;
  color: #2c3e50;
  font-weight: 600;
  text-align: center;
`;

export const SearchIcon = styled(Search)`
  color: #fff;
  height: 18px;
  width: 18px;
  margin-right: 10px;
  margin-top: -5px;
`;

export const DeleteIcon = styled(Delete)`
  color: #fff;
  height: 18px;
  width: 18px;
  margin-right: 10px;
  margin-top: -5px;
`;

export const EditIcon = styled(EditAlt)`
  color: #fff;
  height: 18px;
  width: 18px;
  margin-right: 10px;
  margin-top: -5px;
`;

export const CategoryIcon = styled(Category)`
  color: #fff;
  height: 24px;
  width: 24px;
`;

export const SchoolIcon = styled(School)`
  color: #fff;
  height: 24px;
  width: 24px;
`;

export const NewspaperIcon = styled(Newspaper)`
  color: #fff;
  height: 24px;
  width: 24px;
`;

export const PaperPlaneIcon = styled(PaperPlane)`
  color: #fff;
  height: 24px;
  width: 24px;
`;

export const DeletarIcone = styled(DeleteDismiss)`
  color: red;
  height: 24px;
  width: 24px;
`;

export const LearningAppIcon = styled(LearningApp)`
  color: #fff;
  height: 24px;
  width: 24px;
`;

export const CheckIcon = styled(Check2Circle)`
  color: #007bc6;
  height: 16px;
  width: 16px;
`;

export const CreateIcon = styled(Create)`
  color: #fff;
  height: 24px;
  width: 24px;
`;

export const PencilSquareIcon = styled(PencilSquare)`
  color: #fff;
  height: 24px;
  width: 24px;
`;

export const AtividadeCard = styled.div`
  background: #fff;
  border-radius: 15px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: none;
  overflow: hidden;
  position: relative;
  min-height: 320px;
  display: flex;
  flex-direction: column;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #007bc6, #0056b3, #28a745);
  }
`;

export const AtividadeHeader = styled.div`
  padding: 20px 15px 15px;
  text-align: center;
  position: relative;
  flex-shrink: 0;
`;

export const AtividadeContent = styled.div`
  padding: 0 15px 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const BadgeCustom = styled.span`
  display: inline-block;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
  
  &.tema {
    background: linear-gradient(135deg, #007bff, #0056b3);
    color: white;
  }
  
  &.simulado {
    background: linear-gradient(135deg, #ffc107, #e0a800);
    color: #212529;
  }
  
  &.bonus {
    background: linear-gradient(135deg, #28a745, #1e7e34);
    color: white;
  }
`;

export const DataEntrega = styled.div`
  background: linear-gradient(135deg, #dc3545, #c82333);
  color: white;
  padding: 8px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  margin: 10px 0;
  display: inline-block;
  box-shadow: 0 3px 12px rgba(220, 53, 69, 0.3);
`;

export const BotaoAcao = styled.button`
  background: ${props => {
    if (props.variant === 'warning') return 'linear-gradient(135deg, #ffc107, #e0a800)';
    if (props.variant === 'success') return 'linear-gradient(135deg, #28a745, #1e7e34)';
    if (props.variant === 'danger') return 'linear-gradient(135deg, #dc3545, #c82333)';
    return 'linear-gradient(135deg, #007bff, #0056b3)';
  }};
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  margin: 4px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.2);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 18px rgba(0, 0, 0, 0.3);
    color: white;
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const FiltroContainer = styled.div`
  background: white;
  padding: 25px;
  border-radius: 15px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
  
  .btn-link {
    color: #6c757d;
    text-decoration: none;
    padding: 8px 15px;
    margin: 0 5px;
    border-radius: 20px;
    transition: all 0.3s ease;
    font-weight: 500;
    
    &:hover {
      background: #f8f9fa;
      color: #007bc6;
      text-decoration: none;
    }
  }
  
  hr {
    border-top: 2px solid #e9ecef;
    margin: 20px 0;
  }
`;

export const InfoSection = styled.div`
  margin-bottom: 15px;
  text-align: center;
`;

export const InfoLabel = styled.div`
  color: #6c757d;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 6px;
`;

export const BotoesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  margin-top: auto;
`;

export const NovaAtividadeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  padding: 10px 0;
`;

export const AvisoContainer = styled.div`
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: none;
  overflow: hidden;
  position: relative;
  margin-bottom: 20px;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  }
  
  &.dele {
    padding-right: 50px !important;
  }
`;

export const AvisoTipoIcon = styled.div`
  width: 50px;
  min-width: 50px;
  height: 50px;
  min-height: 50px;
  margin-right: 15px;
  background: linear-gradient(135deg, #007bc6 0%, #0056b3 100%);
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(0, 123, 198, 0.3);
  flex-shrink: 0;
`;

export const AvisoContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  strong {
    color: #2c3e50;
    font-size: 16px;
    margin-bottom: 5px;
    line-height: 1.4;
  }
  
  small {
    color: #6c757d;
    font-size: 12px;
  }
`;

export const FormularioAviso = styled.div`
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: flex-start;
  gap: 15px;
  
  .flex100 {
    flex: 1;
    display: flex;
    flex-direction: column;
    
    .form-control {
      border: 2px solid #e9ecef;
      border-radius: 8px;
      padding: 12px;
      font-size: 14px;
      transition: all 0.3s ease;
      resize: vertical;
      min-height: 80px;
      
      &:focus {
        border-color: #007bc6;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 198, 0.25);
        outline: none;
      }
    }
  }
  
  .btn {
    margin-top: 10px;
    padding: 10px 20px;
    border-radius: 8px;
    font-weight: 600;
    transition: all 0.3s ease;
    
    &.btn-info {
      background: linear-gradient(135deg, #007bc6, #0056b3);
      border: none;
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 5px 15px rgba(0, 123, 198, 0.4);
      }
    }
  }
`;

export const CabecalhoAtividades = styled.div`
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  strong {
    color: #2c3e50;
    font-size: 18px;
    margin: 0;
  }
`;

export const BotaoNovaAtividade = styled.button`
  background: linear-gradient(135deg, #28a745, #1e7e34);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 25px;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
  text-decoration: none;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);
    color: white;
    text-decoration: none;
  }
  
  &:active {
    transform: translateY(0);
  }
  
  svg {
    width: 18px;
    height: 18px;
  }
`;
